import React, { FC, useState } from 'react';

import { Box, Typography } from '@mui/material';

interface JobDetailsRowProps {
  label: string;
  value: string | undefined;
  fieldKey: string;
}

const JobDetailsRow: FC<JobDetailsRowProps> = (props) => {
  const { label, value, fieldKey } = props;
  const [copiedField, setCopiedField] = useState<string | null>(null);

  const displayValue = value || 'N/A';

  const handleCopyField = (value: string, fieldName: string) => {
    navigator.clipboard.writeText(value);
    setCopiedField(fieldName);
    setTimeout(() => setCopiedField(null), 2000);
  };

  return (
    <Box
      role="button"
      tabIndex={0}
      aria-label={`Copy ${label}: ${displayValue}`}
      onClick={() => handleCopyField(displayValue, fieldKey)}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        py: 0.5,
        px: 2,
        borderRadius: 1,
        bgcolor: 'grey.50',
        cursor: 'pointer',
        '&:hover': { bgcolor: 'grey.100' },
        '&:focus': { outline: '2px solid', outlineColor: 'primary.main', outlineOffset: 2 },
      }}
    >
      <Box sx={{ flex: 1 }}>
        <Typography variant="caption" fontWeight={600} sx={{ textTransform: 'uppercase' }}>
          {label}
        </Typography>
        <Typography
          variant="body1"
          fontWeight={500}
          sx={{
            mt: -1,
            fontFamily: 'monospace',
            pointerEvents: 'none',
          }}
        >
          {displayValue}
        </Typography>
      </Box>
    </Box>
  );
};

export default JobDetailsRow;
